import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { Menu, Dropdown, Button,Select, Option } from 'antd';
import TopCategories from "./headerModules/topCategories";
import ProfileSideBar from './headerModules/profileSideBar';
import TaskerSideBar from '../components/TaskerHeaderModules/TaskerSidebar';
import axios from 'axios';
import {loggedin} from '../redux/actions';
import {connect} from 'react-redux';
import socketIOClient from 'socket.io-client';
// import MyAutoComplete from './FileAutoComplete';
import firebase from 'firebase';
import i18next from 'i18next';
import Swal from 'sweetalert2';
import BusinessAutoComplete from './BusinessAutoComplete';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
const fcm_config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DBURL,
    projectId: process.env.REACT_APP_FIREBASE_PROID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASURE_ID
}

if (!firebase.apps.length) {
    firebase.initializeApp(fcm_config);
}else {
    firebase.app(); 
}

const socket = socketIOClient(process.env.REACT_APP_SOCKET_URL);

const mapStateToProps=(props)=> {
    return {
        loginvalue : props.isLogged
    }
}

const mapDispatchToProps=(dispatch)=> {
    return {
        loggedin : (userdata)=>dispatch(loggedin(userdata))
    }
}


// const NavLocationSearch = (props) => {
//     return (
//         <>
//             <div className={"position-relative locationSearchTop mr-auto " + (props.hideOnResponsive ? "d-none d-md-flex " : "")
//                 + (props.showOnResponsive ? " d-flex d-md-none " : "")} >
//                 <div className="search pr-2 w-100 ml-md-2 ml-0">
//                     <BusinessAutoComplete 
//                         selectedName={props.selectedName}
//                         selectedCountry={props.selectedCountry}
//                         selectedCity={props.selectedCity}
//                         selectedCategory={props.selectedCategory}
//                     />
//                 </div>
//             </div>
//         </>
//     );
// }

// const NavLocationSearch = (props) => {

//     return (
//         <>
//             <div className={"position-relative locationSearchTop mr-auto " + (props.hideOnResponsive ? "d-none d-md-flex " : "")
//                 + (props.showOnResponsive ? " d-flex d-md-none " : "")} >
//                 <div className="search pr-2 w-100 ml-md-2 ml-0">
                   
//                       <MyAutoComplete />
//                 </div>
//             </div>

//         </>
//     );
// }

const TaskThings = (props) => {
    var user_info = {}
    if(localStorage.getItem('user') !== null) {
        user_info = JSON.parse(localStorage.getItem('user'));
    }
    return (
        <div className={"" + (props.hideOnResponsive ? "d-none d-md-flex " : "")
        + (props.showOnResponsive ? " d-flex d-md-none " : "")} >
            {/* <button className='btn btn-primary' Link to={ user_info && Object.keys(user_info).length === 0 && user_info.constructor === Object ? {pathname:"/user/user-login", state: { pre_url : '/user/post-task', allocated_services : [] }} : "/user/post-task" }>Sell business</button> */}
            <Link to={ user_info && Object.keys(user_info).length === 0 && user_info.constructor === Object 
                ? { pathname: "/user/user-login", state: { pre_url: "/user/post-task", allocated_services: [] }} 
                : "/user/post-task" }>
                <button className="ant-btn ant-btn-lg ant-btn-block Btns PrimaryBtn lg fM mb-2 mb-sm-0">{i18next.t('Sell Business')}</button>
            </Link>
        {/* <Dropdown
            getPopupContainer={() => document.getElementById('area')}
            trigger={['click']}
            placement="bottomRight"
            overlay={
                <Menu>
                    <Menu.Item key="0">
                        <Link to={ user_info && Object.keys(user_info).length === 0 && user_info.constructor === Object ? {pathname:"/user/user-login", state: { pre_url : '/user/post-task', allocated_services : [] }} : "/user/post-task" }> {i18next.t('Post a Task')} </Link>
                    </Menu.Item>
                    {
                        (user_info && Object.keys(user_info).length === 0 && user_info.constructor === Object) &&
                        <Menu.Item key="1">
                            <Link to="/tasker/tasker-login">{i18next.t('Become a Tasker')} </Link>
                        </Menu.Item>
                    }
                </Menu>
            }>

            <span className="ant-dropdown-link d-flex align-items-center cursorPointer">{i18next.t('Tasks')}   <div className="downIcon ml-2" /> </span>
        </Dropdown> */}
        </div>
    )
}




 const NavLocationSearch = (props) => {
    const { selectedOption, searchQuery, onSearchChange } = props;

    // Dynamic placeholder based on selected option
    const placeholder = `Search by ${selectedOption}`;

    return (
        <div className={"position-relative locationSearchTop mr-auto " + (props.hideOnResponsive ? "d-none d-md-flex " : "")
            + (props.showOnResponsive ? " d-flex d-md-none " : "")} >
            <div className="search pr-2 w-100 ml-md-2 ml-0">
                <BusinessAutoComplete
                    placeholder={placeholder}
                    selectedOption={selectedOption}
                    searchQuery={searchQuery}
                    onSearchChange={onSearchChange}
                />
            </div>
        </div>
    );
};


class BusinessHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logginStatus: false,
            selectedOption: 'Name', // Default dropdown selection
            searchQuery: '', // Search query entered in the search bar
            countries: [],
            cities: [],
            categories: [],
            names: [], // Assuming you have a list of names
        };
    }



    componentDidMount = () => {
        this.get_appdefault();
        this.get_basic_info();
        this.getLocationData();
    }

    get_basic_info = () => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        if(general_info !== null && Object.keys(general_info).length > 0) {
            this.setState({ general_info : general_info });  
        }
        else {
            axios.get(`${process.env.REACT_APP_BASE_URL}/web/api/v1/appdefaults`)
            .then(res => {
                if(res.data.status_code === 200)
                {
                    this.setState({ general_info : res.data });
                }
                else {
                    this.setState({ general_info : {} });
                }
            });
        }
    }


     get_appdefault = () => {
            const {pathname} = this.props.location;
            
            if (localStorage.getItem("user") === null) {
                this.props.loggedin({})
                this.setState({ logginStatus : false })
            }
            else {
                var user_info = JSON.parse(localStorage.getItem('user'));
                if(user_info.type === 'user') {
                    if(pathname === '/user/user-login') {
                        this.props.history.push('/');
                    }
                }
                else {
                    if(pathname === '/tasker/tasker-login') {
                        this.props.history.push('/tasker');
                    }
                }
                this.props.loggedin(user_info)
                this.setState({ logginStatus : true })
            }
        }


    logo_image_err = (ev) => {
        var general_info = JSON.parse(localStorage.getItem('general_info'));
        console.log('general_infologo',general_info);
        ev.target.src = general_info.site_logo;
    }


    getLocationData = async () => {
        try {
            const countriesResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/countries`);
            const citiesResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/cities`);
            const categoriesResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/categories`);
            const namesResponse = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/names`); // Fetch names

            this.setState({
                countries: countriesResponse.data,
                cities: citiesResponse.data,
                categories: categoriesResponse.data,
                names: namesResponse.data,
            });
        } catch (error) {
            console.error("Error fetching location and category data", error);
        }
    }

    handleDropdownChange = (value) => {
        this.setState({ selectedOption: value });
    }

    handleSearchChange = (value) => {
        this.setState({ searchQuery: value });
    }

    render() {
        const { selectedOption, searchQuery } = this.state;

        return (
            <nav className="topNav" id="area">
                <div className="container">
                    <div className="d-flex header">
                        <div className="align-self-center">
                            <div className="align-self-center logo">
                                <Link to={"/"}>
                                    <img onError={this.logo_image_err} src={this.state.general_info && this.state.general_info.site_logo} alt="" className="h-100 w-100" />
                                </Link>
                            </div>
                        </div>

                        <div className="align-self-center ml-3 header_Select">
                            <Select
                                defaultValue="Name"
                                style={{ width: 120 }}
                                onChange={this.handleDropdownChange}
                                dropdownClassName="headermain_dropdown" 
                            >
                                <Select value="Name">Name</Select>
                                <Select value="Country">Country</Select>
                                <Select value="City">City</Select>
                                <Select value="Category">Category</Select>
                            </Select>
                        </div>

                        <div className="align-self-center w-50 header_search">
                            <NavLocationSearch
                                hideOnResponsive
                                selectedOption={selectedOption}
                                searchQuery={searchQuery}
                                onSearchChange={this.handleSearchChange}
                            />
                        </div>

                        <div className="align-self-center ml-auto mr-3">
                            {
                                this.props.user && this.props.user.type === 'user' &&
                                <TaskThings hideOnResponsive user_info={this.props.user ? this.props.user : {}} />
                            }
                            {
                                this.props.user === null &&
                                <TaskThings hideOnResponsive user_info={this.props.user ? this.props.user : {}} />
                            }
                        </div>

                        {!this.props.user ?
                            <div className="align-self-center">
                                <Link to="/user/user-login">
                                    <Button className="PrimaryBtn lg"> {i18next.t('Account')} </Button>
                                </Link>
                            </div> : [
                                (
                                    this.props.user.type === "user" ?
                                        <ProfileSideBar userImage={this.props.user.user_image} userName={this.props.user.name} userInfo={this.props.user} />
                                        :
                                        <TaskerSideBar userImage={this.props.user.user_image} userName={this.props.user.name} userInfo={this.props.user} />
                                ),
                            ]
                        }
                    </div>
                </div>
            </nav>
        );
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(BusinessHeader));